import VideoWizardDestinationStep, {
  VideoWizardDestinationStepProps,
} from './VideoWizardDestinationStep';

export default VideoWizardDestinationStep;
export { VideoWizardDestinationStepProps };
